function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    )
      executeCallback = true;
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) callback(event);
}

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver(entries => {
    entries.forEach(entry => callback(entry));
  }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);
};
// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);
  if (element) {
    let elementHeight = element.offsetHeight;
    document
      .querySelector(appendTo)
      .style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => {
  const roundedVh = Math.round(window.innerHeight * 0.01);
  document.body.style.setProperty("--vh", `${roundedVh}px`);
};
window.addEventListener("resize", getSetVh);

// Browser check
function getBrowser() {
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor") >
      0 ||
    (navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1);
  const isChrome =
    (!!window.chrome &&
      (!!window.chrome.webstore || !!window.chrome.runtime)) ||
    navigator.userAgent.indexOf("Chrome") != -1;
  const isFirefox =
    typeof InstallTrigger !== "undefined" ||
    navigator.userAgent.indexOf("Firefox") != -1;
  const isEdge =
    !!window.StyleMedia || navigator.userAgent.indexOf("Edge") != -1;

  if (isSafari) document.documentElement.classList.add("safari");
  if (isChrome) document.documentElement.classList.add("chrome");
  if (isFirefox) document.documentElement.classList.add("firefox");
  if (isEdge) document.documentElement.classList.add("edge");
}

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document
    .querySelectorAll(qSelectors)
    .forEach(e =>
      e.addEventListener("click", () => toggleBodyClass(bodyClass))
    );
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};
// Cart (delegated so drawer markup can be replaced without losing handlers)
let toggleCart = function () {
  let checkCountry = function () {
    if (typeof Shopify !== undefined && Shopify.country) {
      const country = Shopify.country;
      const shippingCostProgress = document.querySelector(
        ".cart--side-drawer .min-spend"
      );
      if (shippingCostProgress && country !== "SG") {
        document.querySelector(".cart--side-drawer .min-spend").remove();
      }
    }
  };

  document.body.addEventListener("click", function (e) {
    const el = e.target.closest(
      ".carto, .cartc, .cart-overlay--side-drawer"
    );
    if (!el) return;
    document.body.classList.toggle("open-cart");
    document.body.classList.remove("hideheader");
    escapeAmp();
    checkCountry();
  });

  document.body.addEventListener("keydown", function (e) {
    const el = e.target.closest(
      ".carto, .cartc, .cart-overlay--side-drawer"
    );
    if (!el) return;
    if (
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.key === " " ||
      e.code === "Space" ||
      e.keyCode === 32 ||
      e.key === "Escape"
    ) {
      e.preventDefault();
      document.body.classList.toggle("open-cart");
      document.body.classList.remove("hideheader");
    }
  });
};

function initializeDetailsControls() {
  // Handle dropdown menu
  const detailsElementsLv1 = document.querySelectorAll("details.lv1");
  const detailsElementsClosex = [
    ...document.querySelectorAll("details.closex"),
  ];

  function closeOtherDetails(element) {
    const detailsOpened = document.querySelectorAll("details[open].lv1");
    for (const item of detailsOpened) {
      if (element !== item) {
        item.removeAttribute("open");
      }
    }
  }

  function closeAllDetailsExcept(target) {
    detailsElementsClosex.forEach(f =>
      !f.contains(target) ? f.removeAttribute("open") : ""
    );
    a11yDetails();
  }

  function closeAllDetails() {
    detailsElementsClosex.forEach(f => f.removeAttribute("open"));
    a11yDetails();
  }

  // Dropdown menu
  detailsElementsLv1.forEach(item => {
    item.addEventListener("click", function () {
      closeOtherDetails(this);
    });
  });

  // Close details when clicked outside
  document.addEventListener("click", function (e) {
    if (!detailsElementsClosex.some(f => f.contains(e.target))) {
      closeAllDetails();
    } else {
      closeAllDetailsExcept(e.target);
    }
  });

  // Close details with esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      closeAllDetails();
    }
  });

  // Initial accessibility settings
  a11yDetails();
}

// PERF (INP): a11yDetails() runs on every document click and on every
// mouseover/mouseout of the desktop mega menu. It used to add a fresh click
// listener to every summary on each call, so listeners piled up for the life
// of the page and each summary click ran hundreds or thousands of copies.
// Bind once per summary, and only write aria-expanded when it changes.
function a11yDetailsSummaryClick(event) {
  event.currentTarget.setAttribute(
    "aria-expanded",
    !event.currentTarget.closest("details").hasAttribute("open")
  );
}

function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
    const expanded = String(summary.parentNode.hasAttribute("open"));
    if (summary.getAttribute("aria-expanded") !== expanded) {
      summary.setAttribute("aria-expanded", expanded);
    }

    if (summary.dataset.a11yBound) return;
    summary.dataset.a11yBound = "1";

    const panel = summary.nextElementSibling;
    if (panel && panel.getAttribute("id")) {
      summary.setAttribute("aria-controls", panel.id);
    }

    summary.addEventListener("click", a11yDetailsSummaryClick);
  });
}

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// Debug
if (window.location.href.indexOf("debug") > -1) {
  var OpenThinking = OpenThinking || {};
  OpenThinking.theme = {
    name: "Bullet",
    version: `${window.BOOMR.themeVersion}`,
  };
  console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

var palBoxRerenderTimer = null;

function rerenderPalBoxDebounced() {
  if (!document.querySelector(".pal-box-wrapper")) {
    return;
  }
  clearTimeout(palBoxRerenderTimer);
  palBoxRerenderTimer = setTimeout(function () {
    palBoxRerenderTimer = null;
    rerenderPalBox();
  }, 200);
}

// Basket messages as an on-brand modal (a native <dialog>: dims the page, traps
// focus, Esc and a click outside close it) instead of alert(). Used for every
// basket error (sold out, quantity limits, checkout rules such as "the Christmas
// Gallery Set is checked out on its own") and by the set builder.
//
//   showCartModal({ title, message, actions: [{ label, href } | { label, close: true }] })
//   The first action is the primary (yellow) button.
function showCartModal(opts) {
  let dialog = document.getElementById("cart-modal");
  if (!dialog) {
    dialog = document.createElement("dialog");
    dialog.id = "cart-modal";
    dialog.className = "cart-modal";
    dialog.setAttribute("aria-labelledby", "cart-modal-title");
    dialog.innerHTML =
      '<div class="cart-modal__inner">' +
      '<div class="cart-modal__head">' +
      '<p class="cart-modal__title" id="cart-modal-title"></p>' +
      '<button type="button" class="cart-modal__close" aria-label="Close">×</button>' +
      "</div>" +
      '<p class="cart-modal__message"></p>' +
      '<div class="cart-modal__actions"></div>' +
      "</div>";
    dialog.querySelector(".cart-modal__close").addEventListener("click", function () {
      dialog.close();
    });
    // A click on the backdrop lands on the <dialog> itself, not its inner panel.
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });
    document.body.appendChild(dialog);
  }

  dialog.querySelector(".cart-modal__title").textContent = opts.title || "";
  dialog.querySelector(".cart-modal__message").textContent = opts.message || "";
  const actions = dialog.querySelector(".cart-modal__actions");
  actions.innerHTML = "";
  (opts.actions && opts.actions.length ? opts.actions : [{ label: "OK", close: true }]).forEach(function (action, i) {
    const el = document.createElement(action.href ? "a" : "button");
    el.className = "cart-modal__action" + (i === 0 ? " is-primary" : "");
    el.textContent = action.label;
    if (action.href) {
      el.href = action.href;
    } else {
      el.type = "button";
      el.addEventListener("click", function () {
        dialog.close();
      });
    }
    actions.appendChild(el);
  });

  if (dialog.open) dialog.close();
  if (typeof dialog.showModal === "function") {
    dialog.showModal();
    const primary = actions.querySelector(".is-primary");
    if (primary) primary.focus();
  } else {
    alert(opts.message); // very old browsers without <dialog>
  }
}
window.showCartModal = showCartModal;

function showCartNotice(message) {
  // Several refused requests can answer at once; show their message once.
  const open = document.getElementById("cart-modal");
  if (open && open.open) {
    return;
  }
  showCartModal({ title: "Couldn’t add to basket", message: message, actions: [{ label: "OK", close: true }] });
}
window.showCartNotice = showCartNotice;

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
//
// Every add-to-basket button calls ajaxCart(this) on click, and the page calls it
// once on load. It used to bind a fresh ajaxSuccess/ajaxError pair on every call,
// so listeners piled up and one failed add showed its message once per earlier
// click (three alerts after two clicks). Bind once; remember the latest button so
// its loading state is still cleared.
let ajaxCartBound = false;
let ajaxCartButton = null;
function ajaxCart(obj) {
  if (obj) {
    obj.classList.add("loading");
    ajaxCartButton = obj;
  }
  if (ajaxCartBound) {
    return;
  }
  ajaxCartBound = true;

  $(document).ajaxSuccess(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      rerenderPalBoxDebounced();
    }
  });

  // The product page's main button carries aria-disabled="true" (added
  // 4 Dec 2025, commit 225d4de), so product.js never handles it and never clears its loading state;
  // CartJS does the add. Clear "Adding..." here once Shopify has answered.
  $(document).ajaxComplete(function (event, jqxhr, settings) {
    if (/\/cart\/add\.js/.test(settings.url || "") && ajaxCartButton) {
      ajaxCartButton.classList.remove("loading");
    }
  });

  $(document).ajaxError(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      if (ajaxCartButton) {
        ajaxCartButton.classList.remove("loading");
      }
      const errorDescription = jqxhr.responseJSON && jqxhr.responseJSON.description;
      if (errorDescription) {
        showCartNotice(errorDescription);
        console.log(errorDescription);
      }
    }
  });
}

if (typeof jQuery !== "undefined") {
  jQuery(document).on("cart.requestComplete", function (event, cart) {
    if (!cart) {
      return;
    }
    var counter = document.getElementById("counter");
    if (counter) {
      counter.setAttribute("data-count", cart.item_count);
    }
    if (typeof window.bulletApplyShippingFromCart === "function") {
      window.bulletApplyShippingFromCart(cart);
    } else {
      updateShippingProgress(
        cart.items
          .filter(function (i) {
            return !i.title.toLowerCase().includes("gift card");
          })
          .reduce(function (s, i) {
            return s + i.line_price / 100;
          }, 0),
        cart.items
      );
    }
    escapeAmp();
    document.body.classList.add("open-cart");
    document.body.classList.add("hideheader");
    refreshSideDrawerCartFromSection();
  });
}

// Update shipping price progress
function updateShippingProgress(currentCartTotal, cartItems = []) {
  var freeShippingThreshold = 100;
  var shippingPrice = 5;
  if (currentCartTotal === undefined) {
    currentCartTotal = 0;
  }
  // Checking Gift Card only condition
  var isGiftCardOnly = cartItems.every(item =>
    item.title.toLowerCase().includes("gift card")
  );
  var remainingAmount = Math.max(0, freeShippingThreshold - currentCartTotal);
  var spentPercentage = Math.min(
    100,
    (currentCartTotal / freeShippingThreshold) * 100
  );
  var remainingPercentage = 100 - spentPercentage;
  var shippingMessage = document.getElementById("shipping-message");
  var cartShippingPrice = document.getElementById("cart-shipping-price");
  var cartTotalPrice = document.getElementById("cart-total-price");
  if (
    shippingMessage &&
    typeof Shopify !== "undefined" &&
    Shopify.country &&
    Shopify.country === "SG"
  ) {
    if (currentCartTotal >= freeShippingThreshold) {
      shippingMessage.innerHTML = "<b>Free delivery &#10003;</b> This order ships free";
      cartShippingPrice ? cartShippingPrice.innerText = "Free" : '';
    } else if (isGiftCardOnly) {
      console.log("Only Gift Cards in cart, no shipping price displayed.");
      shippingMessage.innerHTML =
        'You\'re SGD <span id="remaining-amount">' +
        remainingAmount.toFixed(2) +
        "</span> away from free delivery";
        cartShippingPrice ? cartShippingPrice.innerText = "Calculated at checkout" : '';
    } else {
      shippingMessage.innerHTML =
        'You\'re SGD <span id="remaining-amount">' +
        remainingAmount.toFixed(2) +
        "</span> away from free delivery";
      cartShippingPrice ? cartShippingPrice.innerText = "$5" : '';
      cartTotalPrice.innerText = `$${currentCartTotal + shippingPrice}`;
    }
    document.getElementById("spent-bar").style.width = spentPercentage + "%";
    document.getElementById("remaining-bar").style.width =
      remainingPercentage + "%";
  } else {
  }
}

function escapeAmp() {
  let cartItems = document.querySelectorAll(".productsInCart span.name");
  if (cartItems.length && document.body.classList.contains("open-cart")) {
    cartItems.forEach(cartItem => {
      if (cartItem.textContent.includes("&amp;")) {
        cartItem.textContent = cartItem.textContent.replace("&amp;", "&");
      }
    });
  }
}

// Bullet marquee
if (!customElements.get("bullet-marquee"))
  customElements.define(
    "bullet-marquee",
    class bulletMarquee extends HTMLElement {
      constructor() {
        super();
        if (window.ResizeObserver)
          new ResizeObserver(this.duration.bind(this)).observe(this);
      }

      duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute("bullet-speed") || 5);
        const contentWidth = entries[0].contentRect.width;

        // Calculate the slowFactor based on content width
        let slowFactor =
          contentWidth <= 375
            ? 1
            : contentWidth >= 1280
            ? 3
            : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (
          (scrollingSpeed *
            slowFactor *
            entries[0].target.querySelector("span").clientWidth) /
          contentWidth
        ).toFixed(3);

        this.style.setProperty("--bullet-speed", `${scrollingDuration}s`);
      }
    }
  );

/*** init app */
function app() {
  getSetVh(); // get Viewport Height
  getBrowser(); // get the browser
  toggleMenu(); // toggle Menu
  toggleCart(); // toggle Cart
  initializeDetailsControls(); // call details
  ajaxCart(); // init cart listeners
}

function rerenderPalBox() {
    fetch(window.Shopify.routes.root)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const cart = document.querySelector('.pal-box-wrapper');
      const cartSource = html.querySelector('.pal-box-wrapper');
      
      if (cart && cartSource) {
          cart.innerHTML = cartSource.innerHTML;
      }
    });
}

var drawerSectionFetchController = 0; // number of the newest drawer redraw
// Set when the drawer refresh was already started straight after an add or
// change succeeded (see below), so the later call from cart.requestComplete
// doesn't fetch the same section a second time.
var drawerRefreshStartedEarly = false;

/*
  PERF (Wave 2, 4 Oct 2026): a faster-feeling cart drawer.
  Every add went: /cart/add.js (0.7 to 1 s on Shopify's side), then CartJS's
  /cart.js, and only after both did the drawer open and fetch ?sections=header
  to redraw itself. Now:
  1. The drawer opens with a loading bar the moment an add is sent.
  2. The ?sections=header redraw starts as soon as add.js or change.js
     succeeds, alongside CartJS's own /cart.js refresh instead of after it.
  Bundled section rendering (sections=header on add/change) was tried and
  dropped: rendering the header inside those requests made them 0.1-0.35 s
  slower, more than the separate fetch costs.
  If an add fails the drawer closes again; the theme's existing handlers then
  behave exactly as before (notice, and the drawer reopening on requestComplete).
*/
(function () {
  if (typeof jQuery === "undefined") {
    return;
  }
  var CART_MUTATIONS = /\/cart\/(add|change)\.js(\?|$)/;
  var openedForAdd = false;

  function isDrawerCart() {
    return document.body.classList.contains("cart-type-side-drawer");
  }
  function drawerEl() {
    return document.querySelector("section.cart.cart--side-drawer");
  }

  jQuery(document).ajaxSend(function (event, jqxhr, settings) {
    if (!isDrawerCart() || !CART_MUTATIONS.test(settings.url || "")) {
      return;
    }
    // Only an add shows the loading state; +, - and remove already show the
    // result straight away (instant drawer, below).
    var drawer = drawerEl();
    if (drawer && /\/cart\/add\.js/.test(settings.url) && !drawer.querySelector(".sh-pending, [data-sh-bumped]")) {
      drawer.classList.add("is-updating");
    }
    if (/\/cart\/add\.js/.test(settings.url) && !document.body.classList.contains("open-cart")) {
      openedForAdd = true;
      document.body.classList.add("open-cart");
      document.body.classList.add("hideheader");
    }
  });

  jQuery(document).ajaxSuccess(function (event, jqxhr, settings) {
    if (!isDrawerCart() || !CART_MUTATIONS.test(settings.url || "")) {
      return;
    }
    refreshSideDrawerCartFromSection(true);
    drawerRefreshStartedEarly = true;
  });

  jQuery(document).ajaxError(function (event, jqxhr, settings) {
    if (!CART_MUTATIONS.test(settings.url || "")) {
      return;
    }
    var drawer = drawerEl();
    if (drawer) {
      drawer.classList.remove("is-updating");
    }
    if (openedForAdd && /\/cart\/add\.js/.test(settings.url)) {
      document.body.classList.remove("open-cart");
      document.body.classList.remove("hideheader");
    }
  });

  jQuery(document).ajaxComplete(function (event, jqxhr, settings) {
    if (!CART_MUTATIONS.test(settings.url || "")) {
      return;
    }
    openedForAdd = false;
  });
})();

/*
  PERF (5 Oct 2026): instant basket drawer.
  +, - and remove used to wait for Shopify's /cart/change.js (0.7-0.9 s, mostly
  other apps' cart code) and then a fresh drawer render (~0.3 s) before anything
  moved. Now the drawer changes on the tap: quantity, line price, subtotal, the
  free-shipping bar and the basket count; a removed line folds away. Shopify
  still gets every change, one at a time, in the background (CartJS queue);
  the drawer is redrawn from Shopify's answer once no taps are waiting, so a
  refused change (e.g. not enough stock) is put right and its message shown.
  Quick taps on one line are merged: one request with the final quantity,
  ~0.35 s after the last tap. Once Shopify refuses more of an item, further +
  taps on it are ignored, so tapping past the stock limit gives one message,
  not one per tap.
  Changes are sent by line-item key (data-sh-key, header-cart.liquid), not by
  line number: Shopify reorders lines when a quantity changes, so with quick
  taps a line number could point at a different product. Lines without a key
  (old cached drawer markup) keep the theme's original behaviour.
*/
var shCartQueued = 0; // lines with a change waiting or on its way
var shBumpedEmpty = false; // instant add showed an empty basket's contents early
(function () {
  if (typeof jQuery === "undefined") {
    return;
  }
  var CHANGE = /\/cart\/change\.js(\?|$)/;
  var SEL = "section.cart--side-drawer [data-cart-update], section.cart--side-drawer [data-cart-remove]";

  var lines = {}; // line key -> { target, sent, timer, busy, refused }
  function recount() {
    shCartQueued = 0;
    for (var k in lines) {
      if (lines[k].timer || lines[k].busy) {
        shCartQueued++;
      }
    }
  }
  function send(key) {
    var st = lines[key];
    st.timer = null;
    if (!st.busy && st.target !== undefined && st.target !== st.sent) {
      st.busy = true;
      st.sent = st.target;
      var done = function (refused) {
        return function () {
          st.busy = false;
          if (refused) {
            // Shopify kept what it could (e.g. all the stock); the redraw
            // shows that. Drop anything tapped since.
            st.refused = true;
            clearTimeout(st.timer);
            st.timer = null;
            st.target = st.sent = undefined;
          } else if (st.target !== st.sent && !st.timer) {
            send(key);
          }
          recount();
        };
      };
      CartJS.updateItemById(key, st.sent, {}, { success: done(false), error: done(true) });
    }
    recount();
  }
  jQuery(document).ajaxError(function (event, jqxhr, settings) {
    // Shopify refused a change (e.g. not enough stock): redraw from its answer.
    if (CHANGE.test(settings.url || "") && jqxhr.status >= 400) {
      setTimeout(function () {
        refreshSideDrawerCartFromSection(true);
      }, 0);
    }
  });

  function cents(text) {
    var m = (text || "").match(/\d[\d,.]*/);
    if (!m) {
      return null;
    }
    var digits = parseInt(m[0].replace(/[.,]/g, ""), 10);
    return /[.,]\d{2}$/.test(m[0]) ? digits : digits * 100;
  }
  function setMoney(el, value) {
    var sample = el.textContent;
    var m = sample.match(/\d[\d,.]*/);
    if (!m) {
      return;
    }
    var s = /[.,]\d{2}$/.test(m[0]) ? (value / 100).toFixed(2) : String(Math.round(value / 100));
    var parts = s.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    el.textContent = sample.replace(m[0], parts.join("."));
  }
  function lastPrice(row) {
    var p = row.querySelectorAll(".box-lelt .price, .box-lelt .box-price > span");
    return p.length ? cents(p[p.length - 1].textContent) : null;
  }

  // Basket count and free-shipping bar from the drawer as it stands; returns
  // the number of items.
  function applyTotals() {
    var items = Array.prototype.map.call(
      document.querySelectorAll("section.cart--side-drawer .side-drawer-inner .productsInCart:not(.sh-removing)"),
      function (r) {
        return {
          title: ((r.querySelector("span.name") || {}).textContent || "").trim(),
          quantity: parseInt((r.querySelector(".qtyinput") || {}).textContent, 10) || 0,
          line_price: lastPrice(r) || 0
        };
      }
    );
    var count = items.reduce(function (n, i) { return n + i.quantity; }, 0);
    var counter = document.getElementById("counter");
    if (counter) {
      counter.setAttribute("data-count", count);
      var hidden = counter.querySelectorAll(".visually-hidden");
      if (hidden.length > 1) {
        hidden[hidden.length - 1].textContent = count;
      }
    }
    if (typeof window.bulletApplyShippingFromCart === "function") {
      window.bulletApplyShippingFromCart({ items: items, item_count: count });
    }
    return count;
  }

  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest(SEL);
    var row = btn && btn.closest(".productsInCart[data-sh-key]");
    var qtyEl = row && row.querySelector(".qtyinput");
    if (!qtyEl || !window.CartJS || typeof CartJS.updateItemById !== "function") {
      return;
    }
    // This tap is handled here, not by CartJS's line-number handler.
    ev.preventDefault();
    ev.stopImmediatePropagation();
    if (row.classList.contains("sh-removing")) {
      return;
    }
    var oldQty = parseInt(qtyEl.textContent, 10) || 0;
    var newQty = btn.hasAttribute("data-cart-remove") ? 0
      : btn.classList.contains("plus") ? oldQty + 1
      : btn.classList.contains("minus") ? oldQty - 1
      : parseInt(btn.getAttribute("data-cart-quantity"), 10) || 0;
    newQty = Math.max(0, newQty);
    var key = row.getAttribute("data-sh-key");
    var st = lines[key] || (lines[key] = {});
    if (newQty > oldQty && st.refused) {
      return; // already at what Shopify can supply
    }
    if (newQty < oldQty) {
      st.refused = false;
    }
    var unit = parseInt(row.getAttribute("data-sh-unit"), 10);
    if (isNaN(unit)) {
      unit = oldQty && lastPrice(row) != null ? Math.round(lastPrice(row) / oldQty) : null;
    }

    st.target = newQty;
    clearTimeout(st.timer);
    st.timer = null;
    if (newQty === 0) {
      send(key);
    } else {
      st.timer = setTimeout(function () {
        send(key);
      }, 350);
      recount();
    }

    // The line: quantity and prices (old and new price both scale with it),
    // or fold it away.
    if (newQty > 0) {
      qtyEl.textContent = newQty;
      row.querySelectorAll(".box-lelt s small, .box-lelt .price, .box-lelt .box-price > span").forEach(function (el) {
        var v = cents(el.textContent);
        if (v != null && oldQty) {
          setMoney(el, Math.round((v * newQty) / oldQty));
        }
      });
    } else {
      // Fold the line away completely (padding too: the rows are border-box
      // with 20px padding, so height 0 alone left a 40px gap that only closed
      // when Shopify's redraw arrived, a second jump), then take it out.
      row.classList.add("sh-removing");
      row.style.overflow = "hidden";
      row.style.height = row.offsetHeight + "px";
      row.style.transition = "height .2s ease, padding .2s ease, opacity .2s ease";
      void row.offsetHeight;
      row.style.height = "0px";
      row.style.paddingTop = "0px";
      row.style.paddingBottom = "0px";
      row.style.opacity = "0";
      setTimeout(function () {
        row.style.display = "none";
      }, 220);
    }

    // Subtotal, basket count and free-shipping bar, from the drawer as it now stands.
    var sub = document.querySelector("section.cart--side-drawer .subtotal-box .subtotal strong");
    if (sub && unit != null && cents(sub.textContent) != null) {
      setMoney(sub, Math.max(0, cents(sub.textContent) + (newQty - oldQty) * unit));
    }
    if (!applyTotals()) {
      var drawer = document.querySelector("section.cart.cart--side-drawer");
      if (drawer) {
        drawer.classList.add("is-updating");
      }
    }
  }, true);

  /*
    Instant add (5 Oct 2026): the drawer used to open empty and only show the
    product once Shopify had added it and the drawer was redrawn (2-3 s on a
    phone). Now the product goes into the drawer as the form is sent: a
    placeholder line from what the page already knows (Shopify's product data
    on the product page; the card itself in "People also loved"), or +qty on
    a line already in the basket. When the add finishes, either way, the
    drawer is redrawn from Shopify, which replaces the placeholder or drops it
    if the add was refused.
  */
  function addInfo(form, variantId) {
    var pal = form.closest(".pal-product");
    if (pal) {
      var pimg = pal.querySelector("img");
      return {
        title: ((pal.querySelector(".pal-product__title") || {}).textContent || "").trim(),
        vendor: "",
        image: pimg ? pimg.currentSrc || pimg.src : "",
        price: cents((pal.querySelector(".pal-product__price") || {}).textContent)
      };
    }
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!meta || !meta.variants) {
      return null;
    }
    var v = meta.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
    if (!v) {
      return null;
    }
    var image = "";
    var imgs = document.querySelectorAll(".slider__slide a.imgzoomer img");
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getBoundingClientRect().width > 0) {
        image = imgs[i].currentSrc || imgs[i].src;
        break;
      }
    }
    if (!image) {
      var og = document.querySelector('meta[property="og:image"]');
      image = og ? og.content : "";
    }
    return { title: v.name, vendor: meta.vendor || "", image: image, price: v.price };
  }

  function formatMoney(value) {
    var fmt = (window.CartJS && CartJS.settings && CartJS.settings.moneyFormat) || "${{amount}}";
    return typeof formatShopifyMoney === "function" ? formatShopifyMoney(value, fmt) : String(value / 100);
  }

  function placeholderRow(info, qty, variantId) {
    var entry = document.querySelector("section.cart--side-drawer .side-drawer-inner .entry");
    if (!entry) {
      return null;
    }
    var model = entry.querySelector(".productsInCart");
    var row;
    if (model) {
      row = model.cloneNode(true);
      row.removeAttribute("data-sh-key");
      row.removeAttribute("data-sh-unit");
      row.removeAttribute("style");
      row.style.gap = "var(--globalBorderWidth)";
      row.querySelectorAll(".cartProperties, .selling-plan, .unit-price").forEach(function (e) { e.remove(); });
      var box = row.querySelector(".box-lelt");
      if (box && box.firstElementChild) {
        box.firstElementChild.outerHTML = '<div><span class="price"></span></div>';
      }
    } else {
      row = document.createElement("div");
      row.className = "productsInCart";
      row.style.gap = "var(--globalBorderWidth)";
      row.innerHTML =
        '<div class="product-left"><div class="image"><img alt="" style="margin-inline:auto;transform:none"></div>' +
        '<div class="name"><div class="vendor"><span></span></div><a class="no-style"><span class="name"></span></a>' +
        '<x-flex ai="center" jc="around" style="gap:.5rem 1rem"><x-cell></x-cell><x-cell><span class="qtyinput"></span></x-cell><x-cell></x-cell></x-flex></div></div>' +
        '<div class="box-lelt"><div><span class="price"></span></div></div>';
    }
    row.classList.add("sh-pending");
    row.setAttribute("data-sh-variant", variantId);
    row.querySelectorAll("[data-cart-update], [data-cart-remove]").forEach(function (b) {
      b.disabled = true;
    });
    var img = row.querySelector(".image img");
    if (img) {
      img.removeAttribute("srcset");
      img.removeAttribute("sizes");
      img.src = info.image;
    }
    var vendor = row.querySelector(".vendor span");
    if (vendor) {
      vendor.textContent = info.vendor;
    }
    var link = row.querySelector("a.no-style");
    if (link) {
      link.removeAttribute("href");
    }
    var name = row.querySelector("span.name");
    if (name) {
      name.textContent = info.title;
    }
    row.querySelector(".qtyinput").textContent = qty;
    var price = row.querySelector(".box-lelt .price");
    if (price) {
      price.textContent = info.price != null ? formatMoney(info.price * qty) : "";
    }
    entry.insertBefore(row, entry.firstChild);
    return row;
  }

  var pendingAdds = 0;
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || form.closest("section.cart:not(.cart--side-drawer)")) {
      return;
    }
    if (!document.body.classList.contains("cart-type-side-drawer")) {
      return;
    }
    var data = new FormData(form);
    var variantId = data.get("id");
    var qty = parseInt(data.get("quantity"), 10) || 1;
    if (!variantId) {
      return;
    }
    // Already in the basket: add to that line.
    var existing = document.querySelector('section.cart--side-drawer .productsInCart[data-sh-key^="' + variantId + ':"]');
    if (existing && !existing.querySelector(".cartProperties li")) {
      var q = existing.querySelector(".qtyinput");
      var old = parseInt(q.textContent, 10) || 0;
      q.textContent = old + qty;
      existing.querySelectorAll(".box-lelt s small, .box-lelt .price, .box-lelt .box-price > span").forEach(function (el) {
        var v = cents(el.textContent);
        if (v != null && old) {
          setMoney(el, Math.round((v * (old + qty)) / old));
        }
      });
      existing.setAttribute("data-sh-bumped", "");
      existing.parentNode.insertBefore(existing, existing.parentNode.firstChild);
    } else {
      var info = addInfo(form, variantId);
      if (!info || !placeholderRow(info, qty, variantId)) {
        return;
      }
    }
    pendingAdds++;
    // An empty basket keeps the drawer's contents hidden until CartJS hears
    // back; tell it now so the line shows.
    if (window.CartJS && CartJS.cart && !(CartJS.cart.item_count > 0)) {
      CartJS.cart.item_count = qty;
      shBumpedEmpty = true;
    }
    applyTotals();
    var drawer = document.querySelector("section.cart.cart--side-drawer");
    if (drawer) {
      drawer.classList.remove("is-updating");
    }
  }, true);

  // However the add was sent (CartJS or the theme's own fetch), redraw from
  // Shopify once it has answered.
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (pendingAdds && /\/cart\/add(\.js)?(\?|$)/.test(e.name)) {
            pendingAdds = Math.max(0, pendingAdds - 1);
            setTimeout(function () {
              refreshSideDrawerCartFromSection(true);
            }, 0);
          }
        });
      }).observe({ type: "resource", buffered: false });
    } catch (e) {}
  }
})();

function refreshSideDrawerCartFromSection(early) {
  if (!document.body.classList.contains("cart-type-side-drawer")) {
    return;
  }
  if (!early && drawerRefreshStartedEarly) {
    drawerRefreshStartedEarly = false;
    return;
  }
  // Each redraw is numbered and only the newest one's answer is used, so an
  // older one still on its way can't overwrite a newer drawer. (It used to be
  // cancelled instead, which left an uncaught AbortError behind.)
  var seq = ++drawerSectionFetchController;
  var path = window.location.pathname || "/";
  var url = path + (path.indexOf("?") === -1 ? "?" : "&") + "sections=header";
  fetch(url)
    .then(function (r) {
      return r.json();
    })
    .then(function (sections) {
      var html = sections.header;
      if (!html || seq !== drawerSectionFetchController) {
        return;
      }
      var doc = new DOMParser().parseFromString(html, "text/html");
      var nextInner = doc.querySelector(
        "section.cart.cart--side-drawer .side-drawer-inner"
      );
      var curInner = document.querySelector(
        "section.cart.cart--side-drawer .side-drawer-inner"
      );
      // Taps still waiting for Shopify: keep the instant view; the last of
      // them redraws the drawer when it succeeds.
      if (nextInner && curInner && !shCartQueued) {
        // Keep the pictures already on screen: a redraw used to make every image
        // new (and lazy), so they blanked and reappeared each time Shopify
        // confirmed a change. Lines keep theirs by line key (a placeholder line by
        // variant); other images ("People also loved") by address.
        var keep = { key: {}, variant: {}, src: {} };
        curInner.querySelectorAll("img").forEach(function (img) {
          if (!img.complete || !img.naturalWidth) {
            return;
          }
          var row = img.closest(".productsInCart");
          if (row && row.getAttribute("data-sh-key")) {
            keep.key[row.getAttribute("data-sh-key")] = img;
          } else if (row && row.getAttribute("data-sh-variant")) {
            keep.variant[row.getAttribute("data-sh-variant")] = img;
          } else if (img.getAttribute("src")) {
            (keep.src[img.getAttribute("src")] = keep.src[img.getAttribute("src")] || []).push(img);
          }
        });
        curInner.innerHTML = nextInner.innerHTML;
        curInner.querySelectorAll("img").forEach(function (img) {
          var row = img.closest(".productsInCart");
          var key = row && row.getAttribute("data-sh-key");
          var old = key && (keep.key[key] || keep.variant[key.split(":")[0]]);
          if (!old && !row && keep.src[img.getAttribute("src")]) {
            old = keep.src[img.getAttribute("src")].shift();
          }
          if (old) {
            old.className = img.className;
            img.replaceWith(old);
          }
        });
        escapeAmp();
        // A refused first add: put the empty-basket view back.
        if (shBumpedEmpty && !curInner.querySelector(".productsInCart") && window.CartJS && CartJS.cart) {
          CartJS.cart.item_count = 0;
        }
        shBumpedEmpty = false;
      }
    })
    .catch(function () {})
    .finally(function () {
      if (seq === drawerSectionFetchController) {
        var drawer = document.querySelector("section.cart.cart--side-drawer");
        if (drawer) {
          drawer.classList.remove("is-updating");
        }
      }
    });
}

function formatShopifyMoney(cents, format) {
  if (
    typeof Shopify !== "undefined" &&
    typeof Shopify.formatMoney === "function" &&
    format
  ) {
    return Shopify.formatMoney(cents, format);
  }
  var formatString = format || "${{amount}}";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = formatString.match(placeholderRegex);
  if (!match) {
    return formatString;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (Number.isNaN(number) || number == null) {
      return "0";
    }
    var s = (number / 100).toFixed(precision);
    var parts = s.split(".");
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    return parts[1] != null ? parts[0] + decimal + parts[1] : parts[0];
  }
  var value;
  switch (match[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }
  return formatString.replace(placeholderRegex, value);
}

window.syncDynamicProductPrice = function (form) {
  if (!form) return;
  var el = form.querySelector(".dynamic-price-value");
  if (!el) return;
  var unitCents = parseInt(el.getAttribute("data-unit-price-cents"), 10);
  if (Number.isNaN(unitCents)) return;
  var qtyInput = form.querySelector(".quantity-input-custom");
  var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
  if (Number.isNaN(qty) || qty < 1) qty = 1;
  var totalCents = unitCents * qty;
  var format = el.getAttribute("data-money-format");
  if (format) {
    el.textContent = formatShopifyMoney(totalCents, format);
    return;
  }
  var currency = el.getAttribute("data-currency") || "USD";
  try {
    el.textContent = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency,
    }).format(totalCents / 100);
  } catch (e) {
    el.textContent = (totalCents / 100).toFixed(2);
  }
};

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});

/*
  PERF (5 Oct 2026): faster taps through to collections and products, mainly on
  phones. Phones have no hover, so Shopify's hover prefetch never starts there.
  On a touch that stays put (a tap, not a scroll), ask the browser to prefetch
  the page so it downloads while the finger is still down. A prefetch only
  downloads the HTML; no scripts run, so analytics doesn't count it.
  (16 Oct 2026: collections now show sold-out products too, so the old rewrite
  of collection links to ?filter.v.availability=1 is gone.)
*/
(function () {
  var PREFETCHABLE = /^\/(collections|products|pages)\//;
  var canSpeculate = window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules");
  var prefetched = {};
  var touchTimer = null;

  function target(a) {
    if (!a || a.target === "_blank" || a.hasAttribute("download")) {
      return null;
    }
    var u;
    try {
      u = new URL(a.getAttribute("href"), location.href);
    } catch (e) {
      return null;
    }
    if (u.origin !== location.origin) {
      return null;
    }
    return u;
  }

  function prefetch(u) {
    var key = u.pathname + u.search;
    if (!canSpeculate || prefetched[key] || !PREFETCHABLE.test(u.pathname) || key === location.pathname + location.search) {
      return;
    }
    prefetched[key] = true;
    var s = document.createElement("script");
    s.type = "speculationrules";
    s.textContent = JSON.stringify({ prefetch: [{ source: "list", urls: [key] }] });
    document.head.appendChild(s);
  }

  function onIntent(e) {
    var a = e.target.closest && e.target.closest("a[href]");
    var u = target(a);
    if (u && e.type === "touchstart") {
      clearTimeout(touchTimer);
      touchTimer = setTimeout(function () {
        prefetch(u);
      }, 60);
    }
  }

  ["pointerover", "touchstart", "mousedown", "focusin"].forEach(function (type) {
    document.addEventListener(type, onIntent, { capture: true, passive: true });
  });
  // The finger moved: a scroll, not a tap.
  document.addEventListener("touchmove", function () {
    clearTimeout(touchTimer);
  }, { capture: true, passive: true });
})();

/*
  Product page, desktop: the gallery badge (SOLD OUT, NEW IN, LAST PIECE...)
  sits on the breadcrumb line, beside whatever else is on that line. The line
  also holds the stock indicator ("In stock", "Low stock"; hidden when sold out)
  on its right, and both change with the variant. So measure: the badge goes
  left of the stock indicator if there is one, at the right end if not, and
  drops below the line (where it used to sit) if the breadcrumb leaves no room.
  Phones are untouched: the breadcrumb is its own row above the photo there.
*/
(function () {
  var DESKTOP = window.matchMedia("(min-width: 778px)");
  var GAP = 12;

  function visible(el) {
    return el && el.offsetWidth > 0 && el.offsetHeight > 0 && getComputedStyle(el).visibility !== "hidden";
  }

  function place() {
    document.querySelectorAll(".bullet-product-media").forEach(function (media) {
      var bc = media.querySelector(".breadcrumb");
      var box = media.querySelector("media-gallery .card-badge-container");
      if (!bc || !box) {
        return;
      }
      box.style.removeProperty("right");
      box.classList.remove("sh-badge-below");
      if (!DESKTOP.matches) {
        return;
      }
      var pill = Array.prototype.filter.call(box.querySelectorAll(".product-badge"), visible)[0];
      var parent = box.offsetParent;
      if (!pill || !parent) {
        return;
      }
      var pr = parent.getBoundingClientRect();
      var inv = bc.querySelector(".inventory");
      var invShown = inv && visible(inv.querySelector(".inventoryStatus") || inv);
      var rightEdge = invShown ? inv.getBoundingClientRect().left - GAP : null;
      if (rightEdge != null) {
        box.style.right = Math.max(0, pr.right - rightEdge) + "px";
      }
      // Room check: the badge must not run into the breadcrumb links.
      var links = bc.querySelectorAll("a, span");
      var crumbsEnd = 0;
      Array.prototype.forEach.call(links, function (el) {
        if (inv && inv.contains(el)) {
          return;
        }
        var r = el.getBoundingClientRect();
        if (r.width) {
          crumbsEnd = Math.max(crumbsEnd, r.right);
        }
      });
      if (pill.getBoundingClientRect().left < crumbsEnd + GAP) {
        box.style.removeProperty("right");
        box.classList.add("sh-badge-below");
      }
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(place, 30);
  }

  function init() {
    if (!document.querySelector(".bullet-product-media .card-badge-container")) {
      return;
    }
    schedule();
    window.addEventListener("load", schedule);
    window.addEventListener("resize", schedule);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule);
    }
    if ("MutationObserver" in window) {
      // Variant changes switch the visible badge (style) and the stock text.
      var mo = new MutationObserver(schedule);
      document.querySelectorAll(".bullet-product-media .card-badge-container, .bullet-product-media .breadcrumb .inventory").forEach(function (el) {
        mo.observe(el, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["style", "class"] });
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Filter groups whose options wait in a <template> (global-filters.liquid):
// build them when the group is opened. "toggle" doesn't bubble, so listen in
// the capture phase.
document.addEventListener(
  "toggle",
  function (e) {
    var group = e.target;
    if (!group.open || !group.querySelectorAll) {
      return;
    }
    group.querySelectorAll("template[data-sh-lazy-options]").forEach(function (tpl) {
      tpl.replaceWith(tpl.content.cloneNode(true));
    });
  },
  true
);
